import { render, staticRenderFns } from "./UdfActionAdd.vue?vue&type=template&id=ca524ae4"
import script from "./UdfActionAdd.vue?vue&type=script&lang=js"
export * from "./UdfActionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports